import { render, staticRenderFns } from "./ServidorPublicoRO.vue?vue&type=template&id=05f35197"
import script from "./ServidorPublicoRO.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoRO.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoRO.vue?vue&type=style&index=0&id=05f35197&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports